import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReadyToBegin() {
  return <section id="ready-to-begin" className="dark bg-background text-foreground relative w-full py-32 md:py-48 flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 w-full h-full bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1571404/img/tiling_toolset_background.png')] bg-cover bg-center bg-fixed" />

      {}
      <div className="absolute inset-0 bg-black/70" />

      {}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-10 tracking-tight drop-shadow-lg">
          Ready to transform your space?
        </h2>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <Button asChild size="lg">
            <Link to="https://simprotile.com/get-a-quote-2/">
              Get a Free Quote
            </Link>
          </Button>
          
          <Link to="#">
            <Button variant="outline" size="lg" className="text-lg px-10 h-14 font-semibold bg-transparent border-2 border-foreground text-foreground hover:bg-foreground hover:text-background hover:border-foreground transition-all duration-300 shadow-xl">
              View Gallery
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}